import type { Calendar, Task } from "@app/core";

/**
 * Drop tasks whose calendar is hidden. A task with no calendar (`calendar_id`
 * null) is always visible. Applied before `expandTasksForCalendar` at every
 * call site so hiding a calendar removes its tasks from the grids AND the
 * All-tasks list.
 */
export function visibleTasks(tasks: Task[], calendars: Calendar[]): Task[] {
  const hidden = new Set(calendars.filter((c) => c.hidden).map((c) => c.id));
  if (hidden.size === 0) return tasks;
  return tasks.filter((t) => !t.calendar_id || !hidden.has(t.calendar_id));
}
